module.exports = __webpack_public_path__ + "img/img11.5d618a0a.png";